/* eslint-disable no-await-in-loop */
import { ActiveWaiter } from '@core/helpers';
import { Publication } from '@dynameat/views/pointOfSale/models';
import { publicationRequest as apiPublicationRequest } from './api';
import { publicationStatus } from './models';

const checkPublication = async (publicationPromise) => {
  const pub = await publicationPromise;
  return pub.generation_status === publicationStatus.PUBLICATED || pub.generation_status === publicationStatus.WITH_ERRORS;
};

const publicationRequest = async (publicationGuid) => {
  const response = await apiPublicationRequest(publicationGuid);
  return Publication.toInstance(response.data);
};

export const getDeployedPublication = (publicationGuid) => new ActiveWaiter(publicationRequest, checkPublication, 5000, [publicationGuid]);
